module.exports = __webpack_public_path__ + "img/aboutus_bg.24abaea2.png";